exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboard{display:flex;flex-direction:row;padding:0 10px 40px 10px}.dashboard .row{width:100%}.dashboard .content{flex:2}.dashboard .screenshot{flex:1;align-items:center;display:flex;flex-direction:column;justify-content:center}\n", ""]);

